export const VIMEO_ID = /^\d{6,12}$/;
export const YOUTUBE_ID = /^[A-Za-z0-9_-]{6,20}$/;

/**
 * Accepts directive attributes ({ vimeo } or { youtube }) or a frontmatter
 * string ("511337314" or "youtube:xlWUDXA5Pmc"). Returns null when invalid.
 */
export function parseVideo(input) {
  if (input && typeof input === "object") {
    if (input.vimeo !== undefined && VIMEO_ID.test(String(input.vimeo))) {
      return { provider: "vimeo", id: String(input.vimeo) };
    }
    if (input.youtube !== undefined && YOUTUBE_ID.test(String(input.youtube))) {
      return { provider: "youtube", id: String(input.youtube) };
    }
    return null;
  }
  const s = String(input ?? "").trim();
  if (VIMEO_ID.test(s)) return { provider: "vimeo", id: s };
  const m = s.match(/^youtube:([A-Za-z0-9_-]{6,20})$/);
  if (m) return { provider: "youtube", id: m[1] };
  return null;
}

export function embedUrl({ provider, id }) {
  return provider === "vimeo"
    ? `https://player.vimeo.com/video/${id}?autoplay=1&dnt=1`
    : `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
}
